import { render, staticRenderFns } from "./base-field-container.vue?vue&type=template&id=d143f954&"
import script from "./base-field-container.vue?vue&type=script&lang=js&"
export * from "./base-field-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports